import localStorageHelper from '../../lib/localStorageHelper';

/**
 * Reset user answers to defaults. Note, this will also re-write
 * answers saved through user API as well (when token is saved).
 */
export default () => (_dispatch, _getState) => {
  if (localStorageHelper.isAccessible()) {
    localStorage.clear();
  }
  window.location.reload();
};
